import React        from "react"
import {NewsLayout} from "sections/News/"
import useNewsData  from "shared/Hooks/News/useNewsData"
import {Images}     from "src/sections/News/NewsLayout/Images";
import {TextBlock}  from "src/sections/News/NewsLayout/TextBlock";
import {NEWS_7}     from "types/News"

const Article = () => {
  const data = useNewsData(NEWS_7);

  return (
    <NewsLayout data={data}>
      <TextBlock data={data.texts.first}/>
      <Images data={data.images.first}/>
    </NewsLayout>
  )
}

export default Article;
